module.exports = __webpack_public_path__ + "img/makeup.86f9b3c5.jpg";